import Schema from './Schema'
import FieldTextarea from'../fields/FieldTextarea'
export default class SchemaTextarea extends Schema {
  constructor(label, key, rules, options, on) {
    super(options)
    FieldTextarea.call(this, label, key, rules, options, on)
  }
}



// WEBPACK FOOTER //
// ./packages/helper/schema/SchemaTextarea.js